const SESSION_SECONDS = 30 * 60;
const DEVICE_SECONDS = 400 * 24 * 60 * 60;
const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function readCookie(documentRef, name) {
	const prefix = `${name}=`;
	const item = documentRef.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(prefix));
	if (!item) return null;
	try { return decodeURIComponent(item.slice(prefix.length)); } catch { return null; }
}

function writeCookie(documentRef, name, value, seconds) {
	const secure = documentRef.location?.protocol === 'https:' ? '; Secure' : '';
	documentRef.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${seconds}; SameSite=Lax${secure}`;
}

export function getWebEventIdentity(analytics, documentRef = document, cryptoRef = crypto) {
	if (!analytics) {
		writeCookie(documentRef, 'bb_sid', '', 0);
		writeCookie(documentRef, 'bb_did', '', 0);
		return {session_id: null, device_id: null};
	}

	let sessionId = readCookie(documentRef, 'bb_sid');
	let deviceId = readCookie(documentRef, 'bb_did');
	if (!UUID_V4.test(sessionId || '')) sessionId = cryptoRef.randomUUID();
	if (!UUID_V4.test(deviceId || '')) deviceId = cryptoRef.randomUUID();
	writeCookie(documentRef, 'bb_sid', sessionId, SESSION_SECONDS);
	writeCookie(documentRef, 'bb_did', deviceId, DEVICE_SECONDS);
	return {session_id: sessionId, device_id: deviceId};
}
